


























import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { UpdateOrgRequest, ApiRequest, QueryRecordsRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { InterpreterProfile } from '../../types/response';
import { ModelSelect } from 'vue-search-select';
import { Condition } from '@/types/queryRequest';
import { Organization, OrgLocation } from '../../types/entity';

@Component({
    mixins: [validationMixin],
    props: {
        id: String,
    },
    validations: {
        interpreterId: {
            required,
        },
    },
      data() {
       return {
            interpreterId: '',
            options: [],
       };
    },
     components: {
        ModelSelect,
    },
})
export default class BlockInterpreterModal extends Vue {
         private show = true;
         private interpreters: InterpreterProfile[] | undefined = [];
         public async mounted() {
               await this.getInterpreterList();
          }
    private async blockInterpreter() {
        const iHttpService = ObjectFactory.getHttpService();
        const updateRequest: UpdateOrgRequest = {
            blockInterpreterId: this.$data.interpreterId,
        };
        const apiRequest: ApiRequest = {
          baseURL: this.$store.state.serverUrl,
          url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.$props.id}/update`,
          data: updateRequest,
          loaderEvent: {
              show: true,
          },
        };
        const response = await iHttpService.put<Organization>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Interpreter blocked successfully..',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private async getInterpreterList() {
        const organization = await ObjectFactory.getOrganizationService().
        getOrgDetailsById(this.$store.state.serverUrl);
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: [{
                op: 'eq',
                fieldName: 'status',
                value: 'VERIFIED',
            }],
            limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
        };
        if (queryRecordsRequest.conditions && organization.data &&
        organization.data.blockedInterpreters && organization.data.blockedInterpreters.length > 0) {
            const condition: Condition = {
                op: 'nin',
                fieldName: 'userId',
                value: organization.data.blockedInterpreters,
            };
            queryRecordsRequest.conditions.push(condition);
        }
        const response = await ObjectFactory.getInterpreterService()
            .getInterpreterList(this.$store.state.serverUrl, queryRecordsRequest);
        if (response.success && response.data) {
            this.$data.options = [];
            this.interpreters = response.data as any;
            response.data.forEach((element) => {
                const option = {
                    value: element.id,
                    text: element.fullname,
                };
                this.$data.options.push(option);
                });
        }
    }

    private close() {
        this.$emit('close');
    }
}
